import React from "react";
import { NavLink } from "react-router-dom";

export default function SideBarLink({ href, name, icon,handleClosemenu }) {
  return (
    <>
      <li>
        <NavLink
          to={href}
          className={({ isActive, isPending }) =>
            isPending ? "" : isActive ? "active" : ""
          }
          onClick={() => {
            handleClosemenu();
          }}
        >
          <span>{icon}</span>
          {name}
        </NavLink>
      </li>
    </>
  );
}
